/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationResponse, UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroup";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsWriteAllowPermissionToGroup } from "../axios/usersAuthzAPIAdminPermissionsWriteAllowPermissionToGroup";
import { useMutation } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationKey = () => ["users-authz-api", { url: '/admin/group/:groupId/permissions/:permission/allow' }] as const

export type UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationKey = ReturnType<typeof usersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationKey>

/**
 * @summary Allow a permission for a group
 * {@link /admin/group/:groupId/permissions/:permission/allow}
 */
export function useUsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroup<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationResponse, ResponseErrorConfig<Error>, {groupId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["permission"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? usersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationKey()

  return useMutation<UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupMutationResponse, ResponseErrorConfig<Error>, {groupId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["groupId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToGroupPathParams["permission"]}, TContext>({
    mutationFn: async({ groupId, permission }) => {
      return usersAuthzAPIAdminPermissionsWriteAllowPermissionToGroup(groupId, permission, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}